'use strict';
module.exports = function isObjectObject(value) {
	if (!value) {
		return false;
	}
	return Object.getPrototypeOf(value) === Object.prototype;
};
